export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  imageUrl: string;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某千万粉丝女主播深夜直播翻车，意外曝光真实颜值惊呆网友',
    summary: '拥有1200万粉丝的知名女主播在昨晚的深夜直播中，因美颜滤镜突然失效，真实容貌瞬间曝光，引发全网热议。直播间弹幕瞬间爆炸，网友纷纷表示"判若两人"。',
    content: '<p>昨晚凌晨2点左右，拥有1200万粉丝的知名女主播"小甜心baby"在进行日常深夜直播时，一场意外的技术故障让她的美颜滤镜突然失效了足足15秒。</p><p>在这15秒内，直播间的观众看到了与她平日精致形象截然不同的真容。据在场网友截图显示，滤镜前后的差异确实相当明显——皮肤状态、五官比例都存在肉眼可见的差别。</p><p>直播间弹幕瞬间爆炸，"这是同一个人？""美颜真的是换头术"等评论疯狂刷屏。该主播在发现异常后迅速关闭了直播，但相关截图已经在各大社交平台疯传。</p><p>截至目前，该主播尚未对此事做出公开回应。其粉丝群体内部也出现了分裂，一部分粉丝表示"早就知道有滤镜"，另一部分则坚持认为"只是状态不好"。</p><p>这已经不是网红圈第一次发生美颜翻车事件。随着直播行业的快速发展，美颜技术的滥用已经成为行业公开的秘密。有业内人士透露，目前市面上主流的美颜软件已经可以实现实时面部重塑，效果堪比"数字整容"。</p>',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    author: '吃瓜一线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20female%20journalist%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20professional%20casual&width=80&height=80&seq=avatar-jizhe-01&orientation=squarish',
    publishDate: '2026-07-07',
    readCount: 128930,
    commentCount: 3421,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20in%20dark%20room%20with%20ring%20light%20surprised%20expression%20smartphone%20screen%20reflecting%20face%20dramatic%20lighting%20warm%20pink%20ambient%20modern%20tech%20setup%20editorial%20photography&width=800&height=500&seq=article-wanghong-01&orientation=landscape',
    tags: ['美颜翻车', '直播事故', '网红塌房', '滤镜'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-2',
    title: '知名吃播博主被曝"假吃"，团队内部聊天记录流出',
    summary: '拥有800万粉丝的吃播大V"大胃王阿强"被前团队成员曝光，疑似长期使用剪辑手法假吃，真实食量远不及视频展示。内部聊天记录截图已在网络广泛传播。',
    content: '<p>今日，一位自称是知名吃播博主"大胃王阿强"前团队成员的用户在社交平台发布长文，并附上多张内部聊天记录截图，指控该博主长期采用剪辑手法进行假吃。</p><p>根据曝光的聊天记录显示，团队会提前准备好多份食物，拍摄时博主只吃少量，然后通过镜头切换和后期剪辑，制造出"大胃王"的假象。剩余的未食用食物则由工作人员处理。</p><p>该爆料一经发出，立即引发广泛关注。不少网友翻出该博主往期视频进行逐帧分析，发现确实存在多处可疑的剪辑痕迹——食物在镜头切换后出现位置变化、碗中食物量不连续等异常情况。</p><p>吃播行业近年来发展迅猛，但"假吃"争议从未间断。从早期的主播催吐到如今的剪辑造假，各种手法层出不穷。有消费者权益保护人士指出，部分吃播博主还借此接食品广告，涉嫌虚假宣传。</p><p>截至目前，"大胃王阿强"方面尚未对此事做出回应，但其最新一条视频的评论区已经被"假吃"相关评论占领。</p>',
    category: '黑料爆料',
    categorySlug: 'heiliao-baoliao',
    author: '八卦探长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20male%20investigator%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20professional&width=80&height=80&seq=avatar-tanzhang-01&orientation=squarish',
    publishDate: '2026-07-06',
    readCount: 98720,
    commentCount: 2856,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mukbang%20food%20table%20full%20of%20dishes%20dramatic%20warm%20lighting%20restaurant%20scene%20behind%20the%20scenes%20vibe%20editorial%20photography%20rich%20colors&width=800&height=500&seq=article-chibo-01&orientation=landscape',
    tags: ['假吃', '吃播', '造假', '内幕曝光'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-3',
    title: '2026年度"最尬才艺大赛"神仙打架，选手翻车合集笑翻全场',
    summary: '一年一度的短视频平台才艺大赛正在火热进行中，各路选手使出浑身解数，但翻车名场面层出不穷。从跑调歌手到灵魂舞者，今年的"尬艺"水平再创新高。',
    content: '<p>2026年度短视频平台才艺大赛正在如火如荼地进行中，与往年不同的是，今年的参赛作品呈现出了前所未有的"翻车率"。</p><p>目前热度最高的是一段名为"灵魂歌唱家"的视频——一位自称"受过专业声乐训练"的选手，在演唱过程中出现了教科书级别的跑调，被网友调侃为"创造了全新的音乐流派"。该视频已获得超过500万次播放。</p><p>紧随其后的是一段"霹雳舞王"的表演，选手在展示高难度地板动作时不慎失去平衡，整个人翻滚出画面。还有一位自称"魔术大师"的选手，在表演纸牌魔术时被自家宠物猫当场揭穿——猫直接叼走了藏在袖口的牌。</p><p>网友们纷纷表示："今年的选手是来搞笑的吧""这才是真正的才艺——让人笑到停不下来"。话题"最尬才艺大赛"已连续三天霸占热搜榜。</p><p>有娱乐评论人分析认为，这种"翻车型"内容的走红，反映了当下年轻人对真实、不做作内容的偏好，也侧面说明了短视频平台的内容生态正在发生变化。</p>',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '大赛观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20observer%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-guancha-01&orientation=squarish',
    publishDate: '2026-07-06',
    readCount: 75200,
    commentCount: 1890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20colorful%20lights%20funny%20moment%20contestants%20performing%20energetic%20vibrant%20atmosphere%20warm%20stage%20lighting%20entertainment%20photography&width=800&height=500&seq=article-dasai-01&orientation=landscape',
    tags: ['才艺大赛', '翻车合集', '搞笑', '短视频'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-4',
    title: '某顶流男星被拍到深夜密会神秘女子，粉丝群炸锅',
    summary: '据目击者爆料，某当红顶流男星于昨日深夜被拍到与一名神秘女子在某高档餐厅共进晚餐，两人举止亲密。消息一出，粉丝群瞬间炸锅。',
    content: '<p>据多位目击者爆料，昨晚约11点左右，某位拥有超过3000万粉丝的顶流男星被拍到与一名年轻女子在北京某高档日料餐厅共进晚餐。</p><p>据目击者描述，两人在用餐期间举止亲密，该男星多次为女方夹菜，期间还有说有笑。用餐结束后，两人一同乘坐保姆车离开，去向不明。</p><p>消息在社交平台发布后，相关话题迅速登上热搜。该男星的粉丝群体反应激烈：一部分"女友粉"表示心碎，"塌房了塌房了"；另一部分理智粉则呼吁"给艺人留私人空间"；还有吃瓜群众表示"坐等官宣"。</p><p>截至目前，该男星的工作室尚未对此事做出回应。而其近期的公开行程显示，他正在为新电影进行宣传，昨日行程确实在北京。</p><p>近年来，顶流偶像的恋情曝光几乎每次都会引发粉丝圈的剧烈震荡。业内人士分析认为，这与偶像经济的运作模式密切相关——偶像的人设往往建立在"单身可追"的基础上，一旦恋情曝光，商业价值可能受到显著影响。</p>',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    author: '八卦前线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20entertainment%20reporter%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-bagua-01&orientation=squarish',
    publishDate: '2026-07-05',
    readCount: 156200,
    commentCount: 5230,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20luxury%20Japanese%20restaurant%20interior%20dim%20warm%20lighting%20two%20silhouettes%20at%20table%20mysterious%20atmosphere%20editorial%20photography%20high%20end%20dining%20scene&width=800&height=500&seq=article-dingliu-01&orientation=landscape',
    tags: ['顶流', '恋情曝光', '粉丝', '八卦'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-5',
    title: '带货主播"最低价"承诺翻车，同款商品在其他平台便宜30%',
    summary: '一名拥有500万粉丝的带货主播在直播间反复强调"全网最低价"，但网友发现同款商品在其他电商平台售价低了近30%，引发消费者维权。',
    content: '<p>"家人们，这绝对是全网最低价，我用人格担保！"——这是带货主播"好物推荐官小王"在最近一场直播中反复强调的话。然而，直播结束不到两小时，就有网友发现同款商品在其他电商平台的售价低了将近30%。</p><p>涉事商品是一款标价299元的智能手表，主播声称这是"独家优惠，错过今天再也没有"。但截图显示，同一品牌同一型号的手表，在另一电商平台的日常售价仅为209元，且支持七天无理由退换。</p><p>事件曝光后，大量购买了该商品的消费者涌入主播评论区要求解释和退款。有消费者表示："相信你才在你这买，结果你就是这样割韭菜的？"</p><p>目前，该主播已删除相关直播回放，但未对事件做出正式回应。平台方面表示已关注到此事件，正在核实情况。</p><p>这并非个例。近年来，直播带货"最低价"翻车事件频发，从美妆到食品再到电子产品，涉及品类广泛。消费者权益保护协会提醒：购物时应多方比价，不要轻信主播的"最低价"承诺。</p>',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    author: '消费观察',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20consumer%20rights%20advocate%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-xiaofei-01&orientation=squarish',
    publishDate: '2026-07-05',
    readCount: 83400,
    commentCount: 2150,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20commerce%20studio%20with%20products%20displayed%20bright%20ring%20light%20smartphone%20on%20tripod%20dramatic%20comparison%20concept%20warm%20lighting%20editorial&width=800&height=500&seq=article-daihuo-01&orientation=landscape',
    tags: ['带货', '最低价', '翻车', '消费者权益'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-6',
    title: '娱乐圈"塑料姐妹花"真相曝光，昔日闺蜜互撕聊天记录流出',
    summary: '娱乐圈两位表面关系亲密的女星，私下互撕聊天记录今日被曝光，言语之激烈令人咋舌。两人曾在多档综艺中以"好闺蜜"形象出现。',
    content: '<p>娱乐圈的"塑料姐妹情"又添新案例。今日，一组据称是某两位当红女星的私人聊天记录在网络上流传，内容之劲爆让吃瓜群众大呼过瘾。</p><p>从曝光的聊天记录来看，两人在私下对彼此的评价与公开场合的表现截然相反。其中一人称对方"演技不行全靠资本捧"，另一人则回击"整容脸还好意思说我"。更令人震惊的是，两人还相互曝光了对方的私生活细节。</p><p>而就在上个月，这两位女星还一同参加了一档热门综艺节目，在节目中互称"最好的闺蜜"，甚至当场落泪讲述她们的"十年友情故事"，感动了无数观众。</p><p>聊天记录曝光后，两人的社交账号评论区双双沦陷。有网友评论："综艺里的眼泪原来都是演技""奥斯卡欠她们一座小金人"。还有网友翻出了两人过往的"闺蜜互动"进行逐帧分析，找到了多处蛛丝马迹。</p><p>截至目前，双方团队均未对此事做出回应。但据业内人士透露，两人的经纪公司正在紧急协商公关方案。</p>',
    category: '黑料爆料',
    categorySlug: 'heiliao-baoliao',
    author: '圈内知情人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20insider%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20mysterious&width=80&height=80&seq=avatar-quannei-01&orientation=squarish',
    publishDate: '2026-07-04',
    readCount: 201500,
    commentCount: 7890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20Chinese%20female%20celebrities%20posing%20together%20on%20red%20carpet%20dramatic%20lighting%20cracked%20glass%20effect%20metaphor%20for%20broken%20friendship%20editorial%20fashion%20photography&width=800&height=500&seq=article-suliaohua-01&orientation=landscape',
    tags: ['塑料姐妹', '聊天记录', '闺蜜', '娱乐圈'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-7',
    title: '直播间"日入十万"神话破灭，真实收入曝光令人唏嘘',
    summary: '一位在直播间频繁宣称"日入十万"的小主播，被知情人士曝光真实收入数据——月均到手不足8000元，所谓的豪车豪宅均为租赁道具。',
    content: '<p>在直播行业，"日入十万""月入百万"的宣传语屡见不鲜，不少主播以此吸引粉丝和潜在从业者。然而，一位前MCN机构运营人员今日发布长文，揭露了这些"财富神话"背后的真相。</p><p>据该运营人员透露，他此前负责的一名主播在直播间常年宣称自己"日入十万"，但实际上该主播月均到手收入不足8000元。直播中展示的豪车是从租车平台按小时租赁的，所谓的豪宅则是通过Airbnb短租的拍摄场地。</p><p>"很多主播的真实情况是：平台抽成50%，MCN再抽20%，剩下的30%还要扣税。一场直播看起来打赏很多，但真正到手的少得可怜。"该运营人员写道。</p><p>更令人震惊的是，他爆料称部分MCN机构会要求主播在直播间"炫富"，并统一提供"炫富道具"——租来的名牌包、借来的豪车钥匙、PS的银行余额截图等。</p><p>此爆料一出，引发了直播行业从业者的广泛共鸣。多位小主播在评论区附和，表示"终于有人说出了真相"。但也有头部主播的粉丝对此表示质疑。</p>',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    author: '行业深喉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20industry%20whistleblower%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20serious&width=80&height=80&seq=avatar-shenhou-01&orientation=squarish',
    publishDate: '2026-07-04',
    readCount: 113600,
    commentCount: 4120,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20room%20setup%20with%20luxury%20props%20fake%20wealth%20display%20contrast%20between%20glamour%20and%20reality%20dramatic%20warm%20lighting%20editorial%20photography&width=800&height=500&seq=article-zhibo-01&orientation=landscape',
    tags: ['直播收入', '炫富', 'MCN', '真相'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-8',
    title: '2026年"最美宠物大赛"暗箱操作？冠军犬主人遭实名举报',
    summary: '在刚刚结束的2026年度"最美宠物大赛"中，获得冠军的柯基犬主人被其他参赛者实名举报，称其在比赛前买通了评委，存在暗箱操作行为。',
    content: '<p>2026年度"最美宠物大赛"刚刚落幕，争议随之而来。今日，多位参赛宠物的主人联合发布实名举报信，指控本届冠军柯基犬"团团"的主人在比赛前通过第三方渠道买通了部分评委。</p><p>举报信中列出了多项疑点：冠军犬在预赛阶段表现平平，排名仅列第七位，但在决赛中却以压倒性优势夺冠；决赛评委组中有两人与冠军犬主人存在商业合作关系；比赛结束后，有评委的社交账号上出现了疑似收受礼物的照片。</p><p>该比赛由某知名宠物品牌赞助，总奖金高达50万元，冠军可获得20万元现金奖励及品牌代言合约。举报者认为，在如此高额的利益驱动下，存在舞弊行为并不奇怪。</p><p>赛事主办方今日发表声明，表示已注意到相关举报，将成立独立调查组对事件进行彻查，调查结果将在一周内公布。</p><p>网友对此事的反应两极分化：狗狗爱好者群体激烈争论，但大量吃瓜群众则表示："宠物比赛都有黑幕，还有什么是真的？"</p>',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    author: '赛事监督员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20contest%20supervisor%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-saishi-01&orientation=squarish',
    publishDate: '2026-07-03',
    readCount: 67800,
    commentCount: 2340,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20corgi%20dog%20on%20pet%20competition%20stage%20with%20trophy%20and%20ribbons%20spotlight%20dramatic%20lighting%20Chinese%20pet%20show%20scene%20colorful%20decorations%20editorial&width=800&height=500&seq=article-chongwu-01&orientation=landscape',
    tags: ['宠物大赛', '暗箱操作', '举报', '黑幕'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-9',
    title: '短视频博主"正能量人设"崩塌，私下辱骂粉丝录音曝光',
    summary: '一位长期以"正能量""暖心姐姐"形象示人的短视频博主，被曝私下对粉丝态度恶劣。一段长达三分钟的辱骂粉丝录音今日在网络上传播。',
    content: '<p>人设崩塌来得猝不及防。今日，一段时长约三分钟的录音在网络上疯传，录音中一名女性声音对电话另一端的人进行了持续的辱骂和贬低。经过粉丝比对确认，录音中的声音属于拥有600万粉丝的"暖心姐姐"——短视频博主"小鹿姐姐"。</p><p>录音内容令人震惊。该博主用极其粗鄙的语言辱骂对方，称粉丝"都是韭菜""没有脑子""活该被割"。这与她在短视频中温柔、善解人意的"暖心姐姐"形象形成了巨大的反差。</p><p>据爆料者称，这段录音是该博主与一位品牌合作方通话的片段。当时合作方因产品质量问题希望协商解决，却遭到了该博主的电话辱骂。</p><p>录音曝光后，"小鹿姐姐"的粉丝数量在两个小时内减少了近30万。大量粉丝在评论区表达失望："关注你三年，没想到你是这样的人""正能量都是演出来的"。</p><p>截至目前，"小鹿姐姐"已在社交平台发布道歉声明，称录音内容"断章取义"，但未提供具体解释。其商务合作方已有多家宣布暂停合作。</p>',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    author: '吃瓜一线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20female%20journalist%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20professional%20casual&width=80&height=80&seq=avatar-jizhe-01&orientation=squarish',
    publishDate: '2026-07-03',
    readCount: 189400,
    commentCount: 6540,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20influencer%20recording%20video%20with%20warm%20smile%20contrast%20dark%20shadow%20behind%20double%20exposure%20style%20duality%20concept%20dramatic%20lighting%20editorial%20photography&width=800&height=500&seq=article-zhengnengliang-01&orientation=landscape',
    tags: ['人设崩塌', '辱骂粉丝', '正能量', '录音曝光'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-10',
    title: '选秀节目选手被曝与导师有不正当关系，节目组紧急回应',
    summary: '某热门选秀节目的一位人气选手被匿名爆料，称其与节目中的某位导师存在超出师生关系的不当交往，并以此获得特殊照顾。节目组今日发布紧急声明。',
    content: '<p>一档正在热播的音乐选秀节目今日陷入争议。匿名爆料者在社交平台发布长文，指控节目中一位人气选手与某位导师存在不正当关系，并因此获得了评委打分上的特殊照顾。</p><p>爆料中附上了多张该选手与导师私下聚会的照片，以及两人深夜出入同一酒店的时间线整理。按照爆料者的说法，这种关系至少已经持续了三个月，期间该选手在节目中的排名从淘汰边缘一路飙升到前三。</p><p>消息传出后，节目组在今日下午紧急发布声明，称"已注意到相关网络传言，节目组始终坚持公平公正的原则，将对相关情况展开内部调查"。但声明并未直接否认爆料内容。</p><p>该选手的粉丝团迅速组织反攻，称这些照片"只是正常师生聚餐"，并质疑爆料时机"有心人在决赛前故意抹黑"。而吃瓜群众则基本站队"相信爆料"，因为"娱乐圈这种事还少吗"。</p><p>有法律界人士指出，如果爆料属实，选秀节目的公平性将受到严重质疑，相关利益方可能面临法律诉讼。</p>',
    category: '黑料爆料',
    categorySlug: 'heiliao-baoliao',
    author: '八卦探长',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20male%20investigator%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone%20professional&width=80&height=80&seq=avatar-tanzhang-01&orientation=squarish',
    publishDate: '2026-07-02',
    readCount: 145800,
    commentCount: 4670,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20stage%20with%20bright%20spotlights%20contestant%20and%20judge%20panel%20dramatic%20tension%20atmosphere%20colorful%20lights%20entertainment%20photography&width=800&height=500&seq=article-xuanxiu-01&orientation=landscape',
    tags: ['选秀', '导师', '内幕', '节目组'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-11',
    title: '游戏主播代打风波升级，多位头部主播被牵连',
    summary: '一场关于游戏主播代打的争议正在持续发酵。继上周某王者荣耀主播被实锤代打后，更多头部主播被网友扒出疑似代打证据。',
    content: '<p>游戏直播圈的"代打门"事件正在雪球般越滚越大。上周，一位拥有400万粉丝的王者荣耀主播被实锤使用代打——即在直播中展示的画面实际由他人操作，主播本人只负责解说和露脸。</p><p>该事件如同打开了潘多拉魔盒。吃瓜群众顺着线索深挖，发现这似乎是行业内的普遍做法。目前已有至少五位头部游戏主播被扒出疑似代打证据，包括：直播中手指操作与画面不同步、摄像头角度刻意避开手部、关键时刻出现"神级操作"与平日水平严重不符等。</p><p>一位自称曾在代打工作室工作过的网友发文称："代打行业早就产业化了。一个直播间背后可能有三四个人——一个负责露脸说话，一个负责打游戏，一个负责查攻略，还有一个负责控评。"</p><p>平台方面表示，已成立专项小组进行调查，一旦查实将永久封禁相关账号。但由于代打行为隐蔽性高，调查取证面临较大困难。</p><p>该事件对游戏直播行业的影响正在显现——多名游戏主播的直播间人气出现明显下滑，观众信任度降至冰点。</p>',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    author: '电竞前线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20reporter%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-dianjing-01&orientation=squarish',
    publishDate: '2026-07-02',
    readCount: 134200,
    commentCount: 3890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20gaming%20streamer%20setup%20with%20multiple%20monitors%20dark%20room%20RGB%20lighting%20suspicious%20atmosphere%20behind%20the%20scenes%20investigation%20concept%20editorial%20photography&width=800&height=500&seq=article-daidai-01&orientation=landscape',
    tags: ['代打', '游戏主播', '直播', '实锤'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-12',
    title: '某综艺节目录制现场突发争执，两位导师当场翻脸离场',
    summary: '昨日在某热门综艺节目录制现场，两位常驻导师因对一位选手的评价产生严重分歧，从口头争论升级为激烈争吵，最终双双摔麦离场，录制被迫中断。',
    content: '<p>综艺节目录制现场的冲突总是最能吸引眼球的。昨日，某热门音乐竞技类综艺在录制新一期节目时，发生了导师当场翻脸离场的戏剧性一幕。</p><p>据现场观众透露，冲突的起因是一位选手的表演评价。导师A给出了极高的评价，称其为"本季最大的惊喜"；而导师B则直言"完全不合格，基本功都有问题"。两种截然相反的评价让现场气氛瞬间紧张。</p><p>两位导师从最初的观点交锋，逐渐升级为互相人身攻击。导师A讽刺导师B"当了几年导师就真以为自己是艺术家了"，导师B则回怼"你连五线谱都看不懂还来当导师"。最终两人同时摔下话筒离场，录制被迫中断了近两个小时。</p><p>节目组在暂停期间紧急调解，最终两位导师在制片人的斡旋下回到现场，完成了剩余录制。但据现场观众反映，之后的气氛"冰到了极点"。</p><p>此事件在社交平台引发热议后有网友翻出了两位导师过往的"恩怨史"——两人早在三年前就因为一次颁奖典礼的座位安排问题有过节。有观众表示："这不是节目效果，这是真恩怨。"</p>',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    author: '综艺一线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20reporter%20portrait%20avatar%20minimal%20style%20clean%20background%20warm%20tone&width=80&height=80&seq=avatar-zongyi-01&orientation=squarish',
    publishDate: '2026-07-01',
    readCount: 178900,
    commentCount: 5230,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20studio%20recording%20set%20with%20red%20judge%20chairs%20dramatic%20confrontation%20atmosphere%20spotlight%20empty%20microphone%20on%20floor%20tense%20mood%20editorial%20photography&width=800&height=500&seq=article-zongyi-01&orientation=landscape',
    tags: ['综艺', '导师', '争执', '录制'],
    isHot: true,
    isExclusive: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.categorySlug === categorySlug);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((article) => article.isHot);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};